import React from 'react';
import './index.css';
import { AuthProvider, useAuth } from './auth/AuthContext';
import SignIn from './components/SignIn';
import Portal from './components/Portal';

function AuthGate() {
  const { isAuthenticated, signOut } = useAuth();

  if (!isAuthenticated) {
    return <SignIn />;
  }

  return <Portal role="admin" onLogout={signOut} />;
}

export default function App() {
  return (
    <AuthProvider>
      <AuthGate />
    </AuthProvider>
  );
}
